import React, { useState } from "react";
import "./styles.css";
import { getDateMMYY } from "../../../Helpers";
import remarks from "../../../Assets/Icons/icon_remark.png";
import report from "../../../Assets/Icons/icon_file.png";
import { usePatientContext } from "../../../Context/PatientContext";
import ViewReportModal from "../../Elements/Modal/viewReportModal";
import { Remarks } from "../Modal/Remarks";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import { getPatientTimeline } from "../../../Services";

const Timeline = ({ view }) => {
  const { patientTimeline, updatePatientTimeline } = usePatientContext();
  const { patientId } = useParams(); /* Read dynamic URL params */
  const { physician } = useAuth();
  const [isViewReportModalOpen, setViewReportModalOpen] = useState(false);
  const [isRemarksModalOpen, setRemarksModalOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectedReportURL, setSelectedReportURL] = useState(null);
  const [selectedReportRemarks, setSelectedReportRemarks] = useState(null);

  // Define a mapping function to transform each entry
  const transformEntry = (entry) => {
    return {
      absoluteDate: entry.date ? new Date(entry.date) : null,
      from: entry.startDate ? new Date(entry.startDate) : null,
      to: entry.endDate ? new Date(entry.endDate) : null,
      eventType: entry?.type,
      eventName: entry?.name,
      details: entry?.description,
      reportKey: entry?.recordURL?.key,
      reportid: entry?.recordURL?._id,
      remarks: entry?.recordURL?.commentsDoc,
    };
  };

  // Map each entry using the transform function
  const transformedData = patientTimeline.map(transformEntry).filter(Boolean);

  // console.log(patientTimeline, "timeline");

  const getReportURL = async (key) => {
    // changeLoader("loader1", true);
    try {
      const getLink = await fetch(
        "https://0t38n05kd3.execute-api.ap-south-1.amazonaws.com/default/presigned_url",
        {
          method: "POST",
          body: JSON.stringify({
            bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
            report_key_array: [key],
          }),
        }
      );
      const link = await getLink.json();
      setSelectedReportURL(link?.presigned_url_array[0]);
      // return link?.presigned_url_array[0];
    } catch {}
    return "";
    // changeLoader("loader1", false);
  };

  // Event handler for when the user clicks the "Send" button
  const updatePatientTimelineRemarks = async (event) => {
    try {
      const timelineResponse = await getPatientTimeline(
        physician.physician._id,
        patientId
      );
      if (!timelineResponse.error) updatePatientTimeline(timelineResponse.data);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  return (
    <div
      className="table-container timeline-container"
      style={view === "expanded" ? { height: "68vh" } : { height: "27vh" }}
    >
      {transformedData.map((item, index) => (
        <div className="event-container" key={index}>
          {item?.absoluteDate ? (
            <div className="time-container">
              <p className="body1 dark-grey">
                {getDateMMYY(item.absoluteDate)}
              </p>
            </div>
          ) : item?.from || item?.to ? (
            <div className="time-container">
              <p className="body1 dark-grey">
                {item?.from && getDateMMYY(item?.from)}
              </p>
              <p className="body1 dark-grey">To</p>
              <p className="body1 dark-grey">
                {item?.to && getDateMMYY(item?.to)}
              </p>
            </div>
          ) : (
            <div className="time-container">
              <p className="body1 dark-grey">No Date Available</p>
            </div>
          )}
          <div className="event-info-container">
            <div className="event">
              <p className="dark-grey">{item?.eventName || item.eventType}</p>
              {/* <p className="body1 medium-grey"> */}
              {item.hasOwnProperty("details") && item.details
                ? item.details.map((detail, indexD) => (
                    <p
                      className="body1 medium-grey"
                      style={{ marginTop: "5px" }}
                      key={indexD}
                    >
                      {detail}
                    </p>
                  ))
                : null}
              {/* </p> */}
            </div>
            <div className="event-btns">
              {/* {item?.remarks?.length > 0 && ( */}
              <button
                className="event-btn remarks"
                onClick={() => {
                  // Open the modal
                  setSelectedReport(item);
                  setSelectedReportRemarks(item.remarks);
                  setRemarksModalOpen(true);
                }}
              >
                <img src={remarks} alt="icon" />
                {item?.remarks?.length} Remarks
              </button>
              {/* )} */}
              {item?.reportKey && (
                <button
                  className="event-btn report"
                  onClick={() => {
                    // Set the selected recordURL and open the modal
                    setSelectedReport(item);
                    getReportURL(item.reportKey);
                    setViewReportModalOpen(true);
                  }}
                >
                  <img src={report} alt="icon" />
                  View Report
                </button>
              )}
            </div>
          </div>
        </div>
      ))}

      {/* Show Edit Record Modal when delete button in the table is clicked*/}
      {isViewReportModalOpen && (
        <ViewReportModal
          screen={"timeline"}
          report={selectedReport}
          reportURL={selectedReportURL}
          onClose={() => setViewReportModalOpen(false)}
        />
      )}

      {/* Show Edit Record Modal when delete button in the table is clicked*/}
      {isRemarksModalOpen && (
        <Remarks
          remarksArray={selectedReportRemarks}
          setRemarksArray={setSelectedReportRemarks}
          patientId={patientId}
          physician={physician}
          report={selectedReport}
          updateTimeline={updatePatientTimelineRemarks}
          onClose={() => setRemarksModalOpen(false)}
        />
      )}
    </div>
  );
};

export default Timeline;
